import React, { createContext, useContext, useMemo } from 'react';
import { useSecurity } from './SecurityContext';
import {
  canAccessAdminRoute,
  getAdminPermissions,
  getAssignableAdminRoles,
  getAdminRoleMeta,
  normalizeAdminRoleCode,
} from '../utils/adminPermissions';

export const AdminPermissionsContext = createContext(null);

export function AdminPermissionsProvider({ children }) {
  const { adminUser, isInitializing } = useSecurity();

  const value = useMemo(() => {
    const roleCode = normalizeAdminRoleCode(adminUser?.role);
    const perms = getAdminPermissions(roleCode);
    return {
      ...perms,
      roleReady: !isInitializing && !!adminUser,
      getRoleMeta: getAdminRoleMeta,
      getAssignableRoles: () => getAssignableAdminRoles(roleCode),
      canAccessRoute: (path) => canAccessAdminRoute(roleCode, path),
      guardWrite: (message = 'Tu rol no tiene permiso para modificar datos.') => {
        if (perms.canWrite) return true;
        return { blocked: true, message };
      },
    };
  }, [adminUser, adminUser?.role, isInitializing]);

  return (
    <AdminPermissionsContext.Provider value={value}>
      {children}
    </AdminPermissionsContext.Provider>
  );
}

export function useAdminPermissionsContext() {
  const ctx = useContext(AdminPermissionsContext);
  if (!ctx) {
    throw new Error('useAdminPermissionsContext debe usarse dentro de AdminPermissionsProvider');
  }
  return ctx;
}
